
export default {
  name: "PromptDialog",
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Dialog: () => import(/* webpackChunkName: "Dialog" */ "./Dialog"),
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    show: {
      default: false,
      required: false,
    },
    // eslint-disable-next-line vue/require-prop-types
    slotted: {
      default: false,
      required: false,
    },
    // eslint-disable-next-line vue/require-prop-types
    title: {
      default: "",
      required: false,
    },
    // eslint-disable-next-line vue/require-prop-types
    text: {
      default: "",
      required: false,
    },
    // eslint-disable-next-line vue/require-prop-types
    type: {
      default: "primary",
      required: false,
    },
    // eslint-disable-next-line vue/require-prop-types
    primaryAction: {
      default: () => ({
        text: "Yes",
      }),
      required: false,
    },
    // eslint-disable-next-line vue/require-prop-types
    secondaryAction: {
      default: () => ({
        text: "Cancel",
      }),
      required: false,
    },
    actionAlign: {
      type: String,
      default: "center",
    },
  },
  data: () => ({
    data: null,
    selected_reason: "",
    additional_reason: "",
  }),
  watch: {
    show(val) {
      if (val) {
        this.open();
      } else {
        this.close();
      }
    },
  },
  methods: {
    open(data) {
      this.data = data;
      this.$refs.Dialog.open();
    },
    close() {
      this.data = null;
      this.$refs.Dialog.cancel();
      this.selected_reason = "";
      this.additional_reason = "";
    },
    accept() {
      this.$emit("accept", {
        ...this.data,
        selected_reason: this.selected_reason,
        additional_reason: this.additional_reason,
      });
      this.$refs.Dialog.close();
      this.selected_reason = "";
      this.additional_reason = "";
    },
  },
};
